import PropTypes from 'prop-types';

import { Button, ElasticModal } from 'basic-components';

import { SNIPPETS } from '../libSuggestions';

import './SnippetsModal.scss';

const snippets = Object.values(SNIPPETS)
const SnippetsModal = ({ addSnippet, onClose }) => (
  <ElasticModal
      className="ng-python-editor__snippets"
      onClose={onClose}
      title="Code snippets"
  >
    {snippets.map(snippet => (
      <div
          className="ng-python-editor__snippets__item"
          key={snippet.name}
      >
        <div className="ng-python-editor__snippets__item__label">
          {snippet.name}
        </div>
        <Button
            onClick={() => addSnippet(snippet)}
            size="small"
            type="button"
            variant="text"
        >
          Insert
        </Button>
      </div>
    ))}
  </ElasticModal>
)

SnippetsModal.propTypes = {
  addSnippet: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
}

export default SnippetsModal;